import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import i18n from '../../i18n/index'

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    // options: {
    //   customProperties: true,
    // },
    light: true,
    themes: {
      light: {
        primary: '#F0B90F',
        secondary: '#12161C',
        accent: '#22DDAE',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      },
      dark: {
        primary: '#F0B90F',
        secondary: '#12161C',
        accent: '#22DDAE',
        error: '#FF5252',
        info: '#2196F3',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  },
  icons: {
    iconfont: 'md',
  },
  lang: {
    t: (key, ...params) => i18n.t(key, params)
  }
});
